import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/_services/user/user.service';
import { Designation } from '../../../../../_helpers/designation';
import { Department } from '../../../../../_helpers/department';

@Component({
  selector: 'app-onboarding-form',
  templateUrl: './onboarding-form.component.html',
  styleUrls: ['./onboarding-form.component.scss']
})
export class OnboardingFormComponent implements OnInit {
  tenantId: string;
  usersForm;
  userCreationForm;
  userDropdownList = [];
  getUserName: any;
  isHRAdmin: boolean;
  userDetails: any;
  requester: any;
  TodayDate: string;
  date: any;
  userCreationId: any;
  userCreationData: any = [];
  isSystem: boolean;
  isNDAAdmin: boolean;
  roles: any = [];
  hrId: any;
  hrName: any;
  isTenantCustomised: boolean;
  designationArray = Designation;
  departmentArray = Department;

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private allocationService: AllocationService,
    private userService: UserService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar) {
    this.usersForm = this.formBuilder.group({
      id: new FormControl(''),
      userId: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/)]),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      displayName: new FormControl('', Validators.required),
      department: new FormControl('', Validators.required),
      phoneNo: new FormControl(''),
      location: new FormControl('', Validators.required),
      joinDate: new FormControl('', Validators.required),
      permanentOrContractor: new FormControl(''),
      alternateEmailId: new FormControl('', Validators.required),
      supervisorId: new FormControl(''),
      supervisonName: new FormControl('', Validators.required),
      currentDesignation: new FormControl('', Validators.required),
      careerStartDate: new FormControl(''),
      middleName: new FormControl('', Validators.required),
      managerId: new FormControl(''),
      managerName: new FormControl('', Validators.required),
      addedToBioMetrics: new FormControl(''),
      totalExperience: new FormControl(''),
      currentExperience: new FormControl(''),
      localId: new FormControl('', [Validators.required, Validators.pattern('#+[0-9]*$')]),
      systemRequiredBoolean: new FormControl(''),
      systemRequired: new FormControl(''),
      roles: new FormControl(''),
      emailIdRequired: new FormControl('', Validators.required),
      status: new FormControl(''),
      birthDate: new FormControl(''),
    })
    this.userCreationForm = this.formBuilder.group({
      id: new FormControl(''),
      requesterId: new FormControl({ value: '', disabled: true }),
      requesterName: new FormControl({ value: '', disabled: true }),
      requestedDate: new FormControl({ value: '', disabled: true }),
      status: new FormControl({ value: '' }),
      userId: new FormControl({ value: '', disabled: true }),
      firstName: new FormControl({ value: '', disabled: true }),
      middleName: new FormControl({ value: '', disabled: true }),
      lastName: new FormControl({ value: '', disabled: true }),
      emailId: new FormControl({ value: '', disabled: true }),
      remarks: new FormControl({ value: '', disabled: true }),
      addedToBioMetrics: new FormControl({ value: '', disabled: true }),
      licenseType: new FormControl({ value: '', disabled: true }),
      licenseRequired: new FormControl({ value: '', disabled: true }),
      licenseAllocation: new FormControl({ value: '', disabled: true }),
      systemRequiredBoolean: new FormControl({ value: '', disabled: true }),
      systemRequired: new FormControl({ value: '', disabled: true }),
      ndaSignedDate: new FormControl({ value: '', disabled: true }),
      biometric: new FormControl({ value: '', disabled: true }),
      ismsTraining: new FormControl({ value: '', disabled: true }),
      ismsAgreement: new FormControl({ value: '', disabled: true }),
      emailIdRequired: new FormControl({ value: '' }),
      ndaSignedBoolean: new FormControl({ value: '' }),
      domainUserId: new FormControl({ value: '' }),
      birthDate: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.getUserList();

    const customisedTenants = ['imtechnologies'];
    this.isTenantCustomised = customisedTenants.includes(this.tenantId);

    this.requester = this.userDetails.id + " . " + this.userDetails.firstName + " " + this.userDetails.lastName;
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;

    this.userCreationForm.value.requesterId = this.requester;
    this.userCreationForm.value.requestedDate = this.TodayDate;
    this.userCreationForm.patchValue(this.userCreationForm.value);

    this.isHRAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleHrmAdministrator');
    this.isNDAAdmin = this.userDetails.admin || this.userDetails.roles.includes('RoleNDATeam');

    this.userCreationId = this.route.snapshot.paramMap.get('id');
    console.log("userCreationId", this.userCreationId)
    if (this.userCreationId) {
      this.getUserCreationById(this.userCreationId);
    }

  }

  // getter for easy access to form fields
  get f() {
    return this.usersForm.controls;
  }

  userCreation() {
    let HRID: number;
    let HRNAME: string;
    if (this.isTenantCustomised) {
      HRID = 153;
      HRNAME = 'Anuja  Wankhade'
    }
    else {
      HRID = this.userDetails.id;
      HRNAME = this.userDetails.firstName + " " + this.userDetails.lastName;
    }

    let user = {
      userId: this.usersForm.get('userId').value,
      localId: this.usersForm.get('localId').value,
      password: this.usersForm.get('password').value,
      firstName: this.usersForm.get('firstName').value,
      middleName: this.usersForm.get('middleName').value,
      lastName: this.usersForm.get('lastName').value,
      displayName: this.usersForm.get('displayName').value,
      department: this.usersForm.get('department').value,
      emailId: this.usersForm.get('alternateEmailId').value,
      alternateEmailId: this.usersForm.get('alternateEmailId').value,
      phoneNo: this.usersForm.get('phoneNo').value,
      location: this.usersForm.get('location').value,
      joinDate: this.usersForm.get('joinDate').value,
      permanentOrContractor: this.usersForm.get('permanentOrContractor').value,
      supervisorId: this.usersForm.get('supervisonName').value.split(' . ')[0],
      supervisonName: this.usersForm.get('supervisonName').value.split(' . ')[1],
      currentDesignation: this.usersForm.get('currentDesignation').value,
      managerName: this.usersForm.get('managerName').value,
      //archived and HR fields are not shown in form
      archived: true,
      hrId: HRID,
      hrName: HRNAME,
      // roles: ["RoleITUser", "RoleHrmUser", "RoleFinanceUser"],
      birthDate: this.usersForm.get('birthDate').value,
    }
    this.userService.createUser(user).subscribe((response: any) => {

      if (response != null) {
        let userCreationDetails = {
          requesterId: this.userDetails.id,
          requesterName: this.userDetails.firstName + " " + this.userDetails.lastName,
          requestedDate: this.TodayDate,
          userId: response.id,
          firstName: response.firstName,
          lastName: response.lastName,
          systemRequiredBoolean: this.usersForm.get('systemRequiredBoolean').value,
          status: 'withNDATeam',
          systemRequired: this.usersForm.get('systemRequired').value,
          emailIdRequired: this.usersForm.get('emailIdRequired').value,
        }

        this.userService.userCreation(userCreationDetails).subscribe((response: any) => {
          this.backToOnboarding();
        })
      }
    })
  }

  getUserCreationById(id) {
    this.userService.getUserCreationById(id).subscribe((response) => {
      console.log("response", response);
      if (response) {
        this.userCreationForm.patchValue({
          requesterId: response.requesterId + " . " + response.requesterName,
          requestedDate: response.requestedDate,
          userId: response.userId + " . " + response.firstName + " " + response.lastName,
          status: response.status,
          remarks: response.remarks,
          addedToBioMetrics: response.addedToBioMetrics,
          licenseType: response.licenseType,
          licenseRequired: response.licenseRequired,
          ismsTraining: response.ismsTraining,
          passwordBoolean: response.passwordBoolean,
          ndaSignedBoolean: response.ndaSignedBoolean,
          ndaSignedDate: response.ndaSignedDate,
        })
      }

      if (response.systemRequiredBoolean === true) {
        this.isSystem = true;
      }

      this.userCreationData = response;
      let systemRequiredValue = response.systemRequired;
      let systemRequiredBooleanValue = response.systemRequiredBoolean;
      let emailIdRequiredValue = response.emailIdRequired;
      let userId = response.userId;
      let status = response.status;
      this.userService.getUser(userId).subscribe((response) => {
        // this.roles = response.roles;
        this.hrId = response.hrId;
        this.hrName = response.hrName;
        this.usersForm.patchValue({
          systemRequiredBoolean: systemRequiredBooleanValue,
          systemRequired: systemRequiredValue,
          emailIdRequired: emailIdRequiredValue,
          userId: response.userId,
          localId: response.localId,
          password: response.password,
          firstName: response.firstName,
          middleName: response.middleName,
          lastName: response.lastName,
          displayName: response.displayName,
          department: response.department,
          alternateEmailId: response.alternateEmailId,
          phoneNo: response.phoneNo,
          location: response.location,
          joinDate: response.joinDate,
          permanentOrContractor: response.permanentOrContractor,
          supervisonName: response.supervisorId + ' . ' + response.supervisonName,
          currentDesignation: response.currentDesignation,
          archived: true,
          managerName: response.managerName,
          status: status,
          birthDate: response.birthDate,
        });
        this.userCreationForm.value.emailId = response.emailId;
        this.userCreationForm.patchValue(this.userCreationForm.value);

        if (status === 'approved') {
          this.usersForm.disable();
        }
      })
    })
  }

  updateUserCreation() {
    let userId = this.userCreationForm.get('userId').value.split(' . ')[0];
    let user = {
      id: parseInt(userId),
      userId: this.usersForm.get('userId').value,
      localId: this.usersForm.get('localId').value,
      firstName: this.usersForm.get('firstName').value,
      middleName: this.usersForm.get('middleName').value,
      lastName: this.usersForm.get('lastName').value,
      displayName: this.usersForm.get('displayName').value,
      department: this.usersForm.get('department').value,
      emailId: this.userCreationForm.get('emailId').value,
      alternateEmailId: this.usersForm.get('alternateEmailId').value,
      phoneNo: this.usersForm.get('phoneNo').value,
      location: this.usersForm.get('location').value,
      joinDate: this.usersForm.get('joinDate').value,
      permanentOrContractor: this.usersForm.get('permanentOrContractor').value,
      supervisorId: parseInt(this.usersForm.get('supervisonName').value.split(' . ')[0]),
      supervisonName: this.usersForm.get('supervisonName').value.split(' . ')[1],
      currentDesignation: this.usersForm.get('currentDesignation').value,
      archived: true,
      managerName: this.usersForm.get('managerName').value,
      // roles: this.roles,
      hrId: this.hrId,
      hrName: this.hrName,
      birthDate: this.usersForm.get('birthDate').value,
    }
    this.userService.updateUser(userId, user).subscribe((response) => {
      let userCreationData = {
        id: parseInt(this.userCreationId),
        requesterId: this.userCreationData.requesterId,
        requesterName: this.userCreationData.requesterName,
        requestedDate: this.userCreationData.requestedDate,
        userId: this.userCreationData.userId,
        firstName: this.userCreationData.firstName,
        lastName: this.userCreationData.lastName,
        emailId: this.userCreationData.emailId,
        status: this.usersForm.get('status').value,
        remarks: this.userCreationData.remarks,
        ndaSignedBoolean: this.userCreationData.ndaSignedBoolean,
        ndaSignedDate: this.userCreationData.ndaSignedDate,
        addedToBioMetrics: this.userCreationData.addedToBioMetrics,
        systemRequiredBoolean: this.usersForm.get('systemRequiredBoolean').value,
        systemRequired: this.usersForm.get('systemRequired').value,
        emailIdRequired: this.usersForm.get('emailIdRequired').value,
        licenseType: this.userCreationData.licenseType,
        licenseRequired: this.userCreationData.licenseRequired,
        licenseAllocation: this.userCreationData.licenseAllocation,
        biometric: this.userCreationData.biometric,
        ismsTraining: this.userCreationData.ismsTraining,
        ismsAgreement: this.userCreationData.ismsAgreement,
        passwordBoolean: this.userCreationData.passwordBoolean,
        domainUserId: this.userCreationData.domainUserId,
      }
      if (response) {
        this.userService.updateUserCreation(this.userCreationId, userCreationData).subscribe((response) => {
          this.backToOnboarding();
        })
      }
    })
  }

  backToOnboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding']);
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  checkSystemStatus(systemStatusValue) {
    let b: string = systemStatusValue.split(': ')[1];
    if (b === 'true') {
      this.isSystem = true;
    }
    else {
      this.isSystem = false;
      this.userCreationForm.patchValue({
        licenseType: ''
      });
    }
  }

  openItonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-it', { id: this.userCreationId }]);
  }

  openHrmonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-form', { id: this.userCreationId }]);
  }

  openndaonboarding() {
    this.router.navigate([this.tenantId + '/dashboard/hr/onboarding-component/onboarding-nda', { id: this.userCreationId }]);
  }
}
